import { FC } from "react";
import Views from "../../../../assets/icon/Views";

interface Props {
  publicationDate: string;
  views: string;
}

const NewsByIdAnalyst: FC<Props> = ({ publicationDate, views }) => {
  return (
    <>
      <div className="flex items-center text-sm">
        <span className="pr-3 opacity-80">{publicationDate}</span>
        <Views />
        <span className="pl-1 opacity-80">{views}</span>
      </div>
    </>
  );
};

export default NewsByIdAnalyst;
